/**
 * Returns whether the document direction is RTL.
 * Reacts to live dir changes via MutationObserver.
 */
import { useState, useEffect } from 'react';

export function useRTL(): boolean {
  const [isRTL, setIsRTL] = useState(
    () => document.documentElement.dir === 'rtl'
  );

  useEffect(() => {
    const el = document.documentElement;
    const observer = new MutationObserver(() => {
      setIsRTL(el.dir === 'rtl');
    });
    observer.observe(el, { attributes: true, attributeFilter: ['dir'] });
    return () => observer.disconnect();
  }, []);

  return isRTL;
}
